import React from 'react';
import PropTypes from 'prop-types';

import AdminPagination from '../Admin/Pagination';
import AdminResultsPerPageSelector from '../Admin/ResultsPerPageSelector';

const DownloadRequestsFooter = ({
  requestsTotal,
  page,
  perPage,
  handleChangePage,
  handleChangePerPage,
}) => (
  <div className="table-footer">
    <AdminResultsPerPageSelector
      perPage={perPage}
      handleChangePerPage={handleChangePerPage}
    />
    <AdminPagination
      total={requestsTotal}
      page={page}
      perPage={perPage}
      handleChangePage={handleChangePage}
    />
  </div>
);

DownloadRequestsFooter.propTypes = {
  requestsTotal: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  perPage: PropTypes.number.isRequired,
  handleChangePage: PropTypes.func.isRequired,
  handleChangePerPage: PropTypes.func.isRequired,
};

export default DownloadRequestsFooter;
